import { useAuthApi, useAuthMutation, ApiBackend } from 'api';
import { enqueueSnackbar } from 'notistack';

export type DuplicateSettingsRequest = {
  source_client_id: number;
  source_node_id: string;
  processes?: string[];
};

export const getNodeData = (clientId: string, nodeId: string) => {
  return useAuthApi([`get-node-data-${clientId}-${nodeId}`], `/node_settings/${clientId}/${nodeId}`, ApiBackend.BACKOFFICE, {
    enabled: !!clientId && !!nodeId,
  });
};

export const getQaNodeData = (clientId: string, nodeId: string) => {
  return useAuthApi(
    [`get-qa-node-data-${clientId}-${nodeId}`],
    `/node_settings/${clientId}/${nodeId}`,
    ApiBackend.QA_BACKOFFICE,
    { enabled: !!clientId && !!nodeId },
  );
};

export const postNodeData = (clientId: string, nodeId: string, callback?: (data: any) => void) =>
  useAuthMutation(
    [`set-node-data-${clientId}-${nodeId}`],
    `/node_settings/${clientId}/${nodeId}`,
    ApiBackend.BACKOFFICE,
    {
      onSuccess: (data) => {
        enqueueSnackbar('Node settings Saved', { variant: 'success', action: () => null });
        if (callback) callback(data);
      },
      onError: (error: any) => {
        const message = error?.response?.data || 'Unable to save node settings';
        enqueueSnackbar(message, { variant: 'error', persist: true });
      },
      retry: false,
    },
    'post',
  );

export const fillPresets = (clientId: string, nodeId: string, callback?: () => void) =>
  useAuthMutation(
    [`fill-presets-${clientId}-${nodeId}`],
    `/node_settings/${clientId}/${nodeId}/fill_presets`,
    ApiBackend.BACKOFFICE,
    {
      onSuccess: () => {
        enqueueSnackbar('Presets applied successfully', { variant: 'success', action: () => null });
        if (callback) callback();
      },
      onError: (error: any) => {
        const message = error?.response?.data || 'Unable to apply presets';
        enqueueSnackbar(message, { variant: 'error', persist: true });
      },
      retry: false,
    },
    'post',
  );

export const duplicateSettings = (clientId: string, nodeId: string, callback?: (settings: any) => void) =>
  useAuthMutation(
    [`duplicate-settings-${clientId}-${nodeId}`],
    `/node_settings/${clientId}/${nodeId}/duplicate`,
    ApiBackend.BACKOFFICE,
    {
      onSuccess: (response: any) => {
        enqueueSnackbar('Settings imported successfully', { variant: 'success', action: () => null });
        if (callback) callback(response.data);
      },
      onError: (error: any) => {
        const message = error?.response?.data || 'Unable to import settings';
        enqueueSnackbar(message, { variant: 'error', persist: true });
      },
      retry: false,
    },
    'post',
  );

export const getNodeSchema = (clientId: string, nodeId: string) =>
  useAuthApi([`get-node-schema-${clientId}-${nodeId}`], `/node_settings/schema/${clientId}/${nodeId}`, ApiBackend.BACKOFFICE, {
    enabled: !!clientId && !!nodeId,
  });
